import { useMemo } from 'react';
import { useQuery } from '@supabase-cache-helpers/postgrest-swr';

import { supabase } from 'src/auth/context/supabase/lib';

// ----------------------------------------------------------------------

export function useGetUsers() {
  const { data, isLoading, error, isValidating } = useQuery(
    supabase.rpc('get_users_with_entities')
  );

  const memoizedValue = useMemo(
    () => ({
      users: data || [],
      usersLoading: isLoading,
      usersError: error,
      usersValidating: isValidating,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export function useGetUsersByEntityId(entity_ids) {
  const { data, isLoading, error, isValidating, mutate } = useQuery(
    supabase.rpc('get_users_by_entities', {
      entity_ids,
    })
  );
  const memoizedValue = useMemo(
    () => ({
      users: data || [],
      usersLoading: isLoading,
      usersError: error,
      usersValidating: isValidating,
      usersMutate: mutate,
    }),
    [data, error, isLoading, isValidating, mutate]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export async function isSuperadmin(id) {
  const { data, error } = await supabase.from('superadmins').select('*').eq('id', id);
  if (error) return error;
  return data.length > 0;
}

// ----------------------------------------------------------------------

export async function getBearerToken() {
  const { data } = await supabase.auth.getSession();
  const accessToken = data.session.access_token;
  return accessToken;
}
